import { useCallback, useState } from "react";

import { httpClient } from "../api/httpClient";

export const useExportColumns = (endpoint, { hiddenFields } = {}) => {
	const [isLoading, setIsLoading] = useState(false);
	const [columns, setColumns] = useState([]);
	const [columnsChoices, setColumnsChoices] = useState([]);

	const loadColumns = useCallback(
		async (filter) => {
			setIsLoading(true);
			try {
				let url = endpoint;
				if (filter && Object.keys(filter).length > 0) {
					const queryString = `filter=${encodeURIComponent(JSON.stringify(filter))}`;
					url = `${endpoint}?${queryString}`;
				}

				const response = await httpClient(url);
				if (response.json) {
					let data = response.json;
					if (hiddenFields?.length) {
						data = data.filter((x) => !hiddenFields.includes(x[0]));
					}
					setColumnsChoices(data.map((x) => ({ id: x[0], name: x[1] })));
					setColumns(data.map((x) => x[0]));
				} else {
					setColumnsChoices([]);
					setColumns([]);
				}
			} catch (error) {
				console.error("Failed to load export columns:", error);
				setColumnsChoices([]);
				setColumns([]);
			} finally {
				setIsLoading(false);
			}
		},
		[endpoint, hiddenFields]
	);

	return { isLoading, columns, columnsChoices, loadColumns };
};
